import React from "react";
import { cn } from "@/lib/utils";
import {
  SERVICES_CATEGORY_TAB_ACTIVE_SHADOW,
  SERVICES_CATEGORY_TAB_HEIGHT,
  SERVICES_CATEGORY_TABS_BG,
  SERVICES_CATEGORY_TABS_GAP,
  SERVICES_CATEGORY_TABS_PADDING,
  SERVICES_PILLS_HEIGHT,
} from "../services/constants";

export type SegmentPillOption<T extends string> = {
  value: T;
  label: string;
};

interface SegmentPillsProps<T extends string> {
  value: T;
  options: SegmentPillOption<T>[];
  onChange: (value: T) => void;
  ariaLabel: string;
}

export function SegmentPills<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
}: SegmentPillsProps<T>) {
  return (
    <div
      className="inline-flex w-fit max-w-full flex-wrap items-center self-start rounded-lg"
      style={{
        minHeight: SERVICES_PILLS_HEIGHT,
        backgroundColor: SERVICES_CATEGORY_TABS_BG,
        padding: SERVICES_CATEGORY_TABS_PADDING,
        gap: SERVICES_CATEGORY_TABS_GAP,
      }}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((pill) => {
        const isActive = value === pill.value;

        return (
          <button
            key={pill.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(pill.value)}
            className={cn(
              "inline-flex shrink-0 items-center justify-center whitespace-nowrap px-2 text-xs font-medium leading-none",
              isActive
                ? [
                    "rounded-md border border-white/0 bg-white text-[#171717]",
                    SERVICES_CATEGORY_TAB_ACTIVE_SHADOW,
                  ]
                : "rounded-md bg-transparent text-[#171717] hover:text-[#525252]",
            )}
            style={{ height: SERVICES_CATEGORY_TAB_HEIGHT }}
          >
            {pill.label}
          </button>
        );
      })}
    </div>
  );
}
